import RefundRequests from "../components/admin/RefundRequests";
import SuperAdminLayout from "../components/layout/SuperAdminLayout";

export default function SuperAdminRefunds() {
  return <RefundRequests canManage={true} Layout={SuperAdminLayout} />;
}
